import { render, staticRenderFns } from "./MtipoequipamientoFormHeader.vue?vue&type=template&id=59a337e4"
import script from "./MtipoequipamientoFormHeader.vue?vue&type=script&lang=js"
export * from "./MtipoequipamientoFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports